import { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
const SeatMapModalContext = /*#__PURE__*/createContext(null);
const SeatMapModalProvider = _ref => {
  let {
    children
  } = _ref;
  const [isSeatMapModalOpen, setIsSeatMapModalOpen] = useState(false);
  const [seatMapCallback, setSeatMapCallback] = useState(() => () => {});
  return /*#__PURE__*/_jsx(SeatMapModalContext.Provider, {
    value: {
      isSeatMapModalOpen,
      setIsSeatMapModalOpen,
      seatMapCallback,
      setSeatMapCallback
    },
    children: children
  });
};
export const useSeatMapModal = () => {
  const context = useContext(SeatMapModalContext);
  if (!context) {
    throw new Error('useSeatMapModal must be used within a SeatMapModalProvider');
  }
  return context;
};
SeatMapModalProvider.propTypes = {
  children: PropTypes.node
};
export default SeatMapModalProvider;
//# sourceMappingURL=SeatMapModalContext.js.map